/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_DocsInputs */

const en_landing_footer_docs = /** @type {(inputs: Landing_Footer_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentation`)
};

const zh_landing_footer_docs = /** @type {(inputs: Landing_Footer_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文档`)
};

/**
* | output |
* | --- |
* | "Documentation" |
*
* @param {Landing_Footer_DocsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_footer_docs = /** @type {((inputs?: Landing_Footer_DocsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_DocsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_footer_docs(inputs)
	return zh_landing_footer_docs(inputs)
});
export { landing_footer_docs as "landing.footer.docs" }